import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class KorisniciService {

  constructor(private _http: Http) { }

  dodajKorisnika(korisnik: any){
    return this._http.post(AppConfig.apiAdresaMongoVimeo + 'users/', korisnik)    
    .map(res => res.json()); 
  }

  dohvatiKorisnike(){
    return this._http.get(AppConfig.apiAdresaMongoVimeo + 'users/?access_token=' + localStorage.getItem('token'))    
    .map(res => res.json()); 
  }

  urediKorisnika(korisnik:any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'users/uredi/' + korisnik['id'], korisnik)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/korisnici/korisnici.service.ts